<template>
  <div class="consoleCamera">
    <!-- 视频控制组件 -->
    <el-card class="box-card">
      <ul class="pie">
        <li @click="handConsoleCamera(videoId, 'up')" class="slice-one slice">
          <el-icon><CaretTop /></el-icon>
        </li>
        <li
          @click="handConsoleCamera(videoId, 'right_up')"
          class="slice-two slice"
        >
          <el-icon><CaretTop /></el-icon>
        </li>
        <li
          @click="handConsoleCamera(videoId, 'right')"
          class="slice-three slice"
        >
          <el-icon><CaretTop /></el-icon>
        </li>
        <li
          @click="handConsoleCamera(videoId, 'right_down')"
          class="slice-four slice"
        >
          <el-icon><CaretTop /></el-icon>
        </li>
        <li
          @click="handConsoleCamera(videoId, 'down')"
          class="slice-five slice"
        >
          <el-icon><CaretTop /></el-icon>
        </li>
        <li
          @click="handConsoleCamera(videoId, 'left_down')"
          class="slice-six slice"
        >
          <el-icon><CaretTop /></el-icon>
        </li>
        <li
          @click="handConsoleCamera(videoId, 'left')"
          class="slice-seven slice"
        >
          <el-icon><CaretTop /></el-icon>
        </li>
        <li
          @click="handConsoleCamera(videoId, 'left_up')"
          class="slice-eight slice"
        >
          <el-icon><CaretTop /></el-icon>
        </li>

        <div class="center">
          <div class="yuan">
            <div
              class="yuan1 xiaoyuan"
              @click="handConsoleCamera(videoId, 'ZOOM_IN')"
            >
              <el-icon style="font-size: 22px; margin: 10px 0 0 10px"
                ><ZoomIn
              /></el-icon>
            </div>
            <div
              class="yuan2 xiaoyuan"
              @click="handConsoleCamera(videoId, 'ZOOM_OUT')"
            >
              <el-icon style="font-size: 22px; margin: 10px 0 0 10px"
                ><ZoomOut
              /></el-icon>
            </div>
            <div
              class="yuan3 xiaoyuan"
              @click="handConsoleCamera(videoId, 'FOCUS_FAR')"
            >
              <span style="margin: 0 0 10px 8px">近焦</span>
            </div>
            <div
              class="yuan4 xiaoyuan"
              @click="handConsoleCamera(videoId, 'FOCUS_NEAR')"
            >
              <span style="margin: 0 8px 10px 0">远焦</span>
            </div>
          </div>
        </div>
      </ul>
    </el-card>
  </div>
</template>

<script>
import { controlCamera } from "@/api/stationBaseInfo";

export default {
  props: ["videoId"],
  data() {
    return {};
  },
  created() {},
  methods: {
    handConsoleCamera(videoId, command) {
      // return
      controlCamera({
        id: videoId,
        command: command,
      }).then((res) => {
        console.log(res);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.consoleCamera {
  position: absolute;
  left: 80%;
  top: 28%;
  z-index: 100;
  background-repeat: no-repeat;
  background-size: 220px 220px;
  background-position: 9px 22px;
  transform: scale(0.7);
  border-radius: 50%;
}
.box-card {
  height: 100%;
}
.el-card {
  border: 0;
  background-color: rgba(255, 255, 255, 0);
  border-radius: 50%;
}
.pie {
  position: relative;
  margin: 0px auto;
  padding: 0;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  list-style: none;
}

.center {
  position: absolute;
  top: 50px;
  left: 50px;
  .yuan {
    transform: scale(0.9);

    display: flex;
    flex-wrap: wrap;
    width: 100px;
    height: 100px;
    .xiaoyuan {
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      box-sizing: border-box;
      color: rgba(0, 0, 0, 0.466);
      cursor: pointer;
      &:hover {
        background-color: #e7e7e7;
      }
      &:active {
        background-color: #1890ff;
        color: white;
      }
    }
    .yuan1 {
      background-color: rgb(207, 207, 207);
      border-top-left-radius: 100%;
      border-right: 1px solid rgba(0, 0, 0, 0.445);
      border-bottom: 1px solid rgba(0, 0, 0, 0.445);
      height: 51px;
    }
    .yuan2 {
      background-color: rgb(207, 207, 207);
      border-top-right-radius: 100%;
      width: 49px;
    }
    .yuan3 {
      background-color: rgb(207, 207, 207);
      border-bottom-left-radius: 100%;
      width: 49px;
    }
    .yuan4 {
      background-color: rgb(207, 207, 207);
      border-bottom-right-radius: 100%;
      border-left: 1px solid rgba(0, 0, 0, 0.445);
      border-top: 1px solid rgba(0, 0, 0, 0.445);
      height: 51px;
      position: relative;
      bottom: 1px;
    }
  }
}

.slice {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 50%;
  transform-origin: 0% 100%;
}

.slice-one {
  transform: rotate(-22.5deg) skewY(-45deg);
  background-color: #666;
  cursor: pointer;
  &:hover {
    background-color: #7a7a7a;
  }
  &:active {
    background-color: #1890ff;
    color: white;
  }
}

.slice-one i {
  font-size: 42px;
  color: white;
  border-radius: 5px;
  transform: skewY(45deg) rotate(22.5deg);
  margin-top: 40px;
  margin-left: 8px;
}

.slice-two {
  transform: rotate(22.5deg) skewY(-45deg);
  background-color: #666;
  cursor: pointer;
  &:hover {
    background-color: #7a7a7a;
  }

  &:active {
    background-color: #1890ff;
    color: white;
  }
}

.slice-two i {
  font-size: 42px;
  color: white;
  border-radius: 5px;
  transform: skewY(45deg) rotate(22.5deg);
  margin-top: 40px;
  margin-left: 8px;
}

.slice-three {
  background-color: #666;
  cursor: pointer;
  &:hover {
    background-color: #7a7a7a;
  }

  &:active {
    background-color: #1890ff;
    color: white;
  }
  transform: rotate(67.5deg) skewY(-45deg);
}

.slice-three i {
  font-size: 42px;
  color: white;
  border-radius: 5px;
  transform: skewY(45deg) rotate(22.5deg);
  margin-top: 40px;
  margin-left: 8px;
  //
}

.slice-four {
  transform: rotate(112.5deg) skewY(-45deg);
  background-color: #666;
  cursor: pointer;
  &:hover {
    background-color: #7a7a7a;
  }

  &:active {
    background-color: #1890ff;
    color: white;
  }
}

.slice-four i {
  font-size: 42px;
  color: white;
  border-radius: 5px;
  transform: skewY(45deg) rotate(22.5deg);
  margin-top: 40px;
  margin-left: 8px;
}

.slice-five {
  transform: rotate(157.5deg) skewY(-45deg);
  background-color: #666;
  cursor: pointer;
  &:hover {
    background-color: #7a7a7a;
  }

  &:active {
    background-color: #1890ff;
    color: white;
  }
}

.slice-five i {
  font-size: 42px;
  color: white;
  border-radius: 5px;
  transform: skewY(45deg) rotate(22.5deg);
  margin-top: 40px;
  margin-left: 8px;
}

.slice-six {
  transform: rotate(202.5deg) skewY(-45deg);
  background-color: #666;
  cursor: pointer;
  &:hover {
    background-color: #7a7a7a;
  }

  &:active {
    background-color: #1890ff;
    color: white;
  }
}

.slice-six i {
  font-size: 42px;
  color: white;
  border-radius: 5px;
  transform: skewY(45deg) rotate(22.5deg);
  margin-top: 40px;
  margin-left: 8px;
}

.slice-seven {
  transform: rotate(247.5deg) skewY(-45deg);
  background-color: #666;
  cursor: pointer;
  &:hover {
    background-color: #7a7a7a;
  }

  &:active {
    background-color: #1890ff;
    color: white;
  }
}

.slice-seven i {
  font-size: 42px;
  color: white;
  border-radius: 5px;
  transform: skewY(45deg) rotate(22.5deg);
  margin-top: 40px;
  margin-left: 8px;
}

.slice-eight {
  transform: rotate(292.5deg) skewY(-45deg);
  background-color: #666;
  cursor: pointer;
  &:hover {
    background-color: #7a7a7a;
  }

  &:active {
    background-color: #1890ff;
    color: white;
  }
}

.slice-eight i {
  font-size: 42px;
  color: white;
  border-radius: 5px;
  transform: skewY(45deg) rotate(22.5deg);
  margin-top: 40px;
  margin-left: 8px;
}

/deep/.el-card__body {
  padding: 0;
}
</style>
